export default function AccessDenied() {
  return <div>You have no power here!</div>;
}
